import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/optimize_logo dark.png";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import AppsDropdown from "../../components/Common/TopbarDropdown/AppsDropdown";
import { usePageGrid } from "../../context/PageGridContext";

const Header = (props) => {
  const role    = localStorage.getItem("role");
  const isAdmin = role === "admin";
  const ctx     = usePageGrid();
  const [search, setsearch] = useState(false);

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }
   const authToken =localStorage.getItem("access");
  // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");

  const fetchMachines = async () => {
    try {
      // Fetch data from your API
      const response = await fetch(
         "https://api.hanoch.in/api/machines",
        {
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`,
          // },
        }
      );

      if (response.ok) {
        const data = await response.json();

        // Check if the arrays are defined before setting them in the state
        setMachines(data);

        //console.log(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  useEffect(() => {
  
    fetchMachines();
  }, []);

  const handleMachineChange = async (event) => {
    const selectedMachineId = event.target.value;

  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div
              className="navbar-brand-box text-center"
              
            >
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="logo-dark" height="24" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="77" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="77" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <form className="app-search d-lg-block">
              <div className="position-relative">
                <select
                  value={selectedMachine}
                  onChange={handleMachineChange}
                  style={{
                    padding: "5px",
                    margin: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <option value="">Select a machine</option>
                  {machines?.map((machine) => (
                    <option key={machine._id} value={machine._id}>
                      {machine.machine_name}
                    </option>
                  ))}
                </select>
              </div>
            </form>
          </div>

          <div className="d-flex d-none">
            <div className="dropdown d-inline-block d-lg-none d-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" />
              </button>

              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* <LanguageDropdown /> */}

            {/* <AppsDropdown /> */}

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>

            {/* Admin-only layout controls */}
            {isAdmin && (
              <div className="d-flex align-items-center gap-2 me-2" style={{ borderRight: "1px solid #e9ecef", paddingRight: "10px" }}>
                <button className="btn btn-sm btn-outline-secondary" style={{ fontSize: 12, padding: "4px 10px" }}
                  onClick={() => ctx?.triggerEdit()}>
                  <i className="mdi mdi-pencil-ruler me-1" />Edit Layout
                </button>
                <button className="btn btn-sm btn-outline-primary" style={{ fontSize: 12, padding: "4px 10px" }}
                  onClick={() => ctx?.triggerWidgets()}>
                  <i className="mdi mdi-tune me-1" />Widgets
                </button>
              </div>
            )}

            <ProfileMenu />

            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
